import Footer from "components/Footer";
import Navbar from "components/Navbar";
import LoginPage from "pages/public/Auth/LoginPage";
import Complaint from "pages/public/Denuncia";
import HomePage from "pages/public/Home";
import { Navigate, Route, Routes } from "react-router-dom";
import { useEffect, useState } from "react";
import Contato from "pages/public/Contato";
import ReadBlog from "pages/public/Blog/Read";
import BrowseBlog from "pages/public/Blog/Browse";
import PoliticaPrivacidadePage from "pages/public/PoliticaPrivacidade";
import TermosUsoPage from "pages/public/TermosUso";
import TrabalheConoscoPage from "pages/public/TrabalheConosco";
import { toggleAppTheme } from "utilities/helpers";
import { Icon } from "@mui/material";
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';

const GuestRoutes = () => {
  // this structure is to get the scroll position
  // a lot of components are using this so dont delete it :)
  const [on_top, setOnTop] = useState(true);
  const [force_on_top, setForceOnTop] = useState(false);
  useEffect(() => {
    window.onscroll = () => {
      if (force_on_top) {
        setOnTop(false);
        return;
      }

      if (window.pageYOffset < 50) {
        setOnTop(true);
      } else {
        setOnTop(false);
      }
    };

    return () => (window.onscroll = null);
  });

  // dark white mode structure
  const [dark_mode, setDarkMode] = useState(false);

  return (
    <>
      <Navbar {...{ on_top, setOnTop, dark_mode, setForceOnTop }} />

      <Routes>
        {/* index */}
        <Route path={"/*"} element={<HomePage {...{dark_mode}}  />} />

        <Route path={"/faca-uma-denuncia"} element={<Complaint />} />
        <Route path={"/contato"} element={<Contato />} />
        <Route path={"/trabalhe-conosco"} element={<TrabalheConoscoPage />} />

        <Route
          path={"/politica-de-privacidade"}
          element={<PoliticaPrivacidadePage {...{dark_mode}} />}
        />
        <Route path={"/termos-de-uso"} element={<TermosUsoPage {...{dark_mode}} />} />

        {/* blog */}
        <Route path={"/blog/navegar"} element={<BrowseBlog />} />
        <Route path={"/blog/ler/:id"} element={<ReadBlog />} />

        {/* auth */}
        <Route path={"/login"} element={<LoginPage />} />

        {/* generic 404 */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>

      <Icon
        component={dark_mode ? DarkModeIcon : LightModeIcon}
        onClick={() => {
          if (toggleAppTheme() === "dark-mode") setDarkMode(false);
          else setDarkMode(true);
        }}
        style={{
          position: "fixed",
          zIndex: 100,
          bottom: "1.4rem",
          right: "0.6rem",
          fontSize: "2rem",
          borderRadius: "50%",
          color: "var(--text-color0)",
          cursor: "pointer",
        }}
      />

      <Footer {...{dark_mode}} />
    </>
  );
};

export default GuestRoutes;
